<!--
 * @Description: 复用供应商的
 * @Date: 2023-12-11 18:53:22
-->
<template>
  <div class="send-msg-code">
    <el-button
      v-if="time == 0"
      type="primary"
      class="send-msg-btn"
      @click="clickHandler"
    >
      获取验证码
    </el-button>
    <el-button v-else type="primary" class="send-msg-btn" disabled>
      {{ `${time}s` }}
    </el-button>
  </div>
</template>

<script>
import { setTimeout } from 'timers';

export default {
  data() {
    return {
      time: 0,
      flag: false,
      timer: ''
    };
  },
  props: {
    phone: {
      type: String | Number
    },
    imgCode: {
      type: String | Number
    },
    getMsgCodeFn: {
      type: Function
    }
  },
  computed: {},
  methods: {
    clickHandler() {
      this.$emit('getMsg');
    },
    runTimer() {
      this.flag = true;
      if (this.time != 0) {
        this.$message({
          message: '短信验证码已发送，请稍后再试',
          type: 'warning'
        });
        this.flag = false;
        return;
      }
      if (`${this.imgCode}`.length < 4) {
        this.$notify({
          title: '失败',
          message: '请输入有效的图形验证码~',
          type: 'error'
        });
        this.flag = false;
        return;
      }
      try {
        this.time = 60;
        this.flag = false;
        this.countDown(this.time);
        this.$emit('click');
      } catch (error) {
        this.flag = false;
      }
    },
    countDown(nowTime) {
      if (nowTime > 0) {
        this.timer = setTimeout(() => {
          this.time = --nowTime;
          this.countDown(this.time);
        }, 1000);
      }
    }
  },
  created() {},
  mounted() {},
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  filters: {}
};
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.send-msg-code {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.send-msg-btn {
  width: 104px !important;
  height: 40px !important;
  border-radius: 2px !important;
  border: 1px solid #1890ff !important;
  color: #1890ff !important;
  background: #fff !important;
  display: inline-block !important;
  padding: 0 !important;
}
</style>
